var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "orderDetails",
      staticStyle: { "margin-bottom": "60px" },
      attrs: { id: "page_Container" }
    },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "main-container", attrs: { id: "main-container" } },
          [
            _c(
              "div",
              { staticClass: "jyType" },
              [
                _c(
                  "van-row",
                  [
                    _c(
                      "van-col",
                      { staticClass: "colLeft", attrs: { span: "14" } },
                      [
                        _c("p", [_vm._v(_vm._s(_vm.dataDetails.statusStr))]),
                        _vm._v(" "),
                        _vm.dataDetails.lockFlag !== 0
                          ? _c("div", { staticClass: "statusStr" }, [
                              _vm._v(_vm._s(_vm.getStatusStr(_vm.dataDetails)))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataDetails.status ===
                          _vm.orderStatus.pendingReceipt &&
                        _vm.dataDetails.deliveryTime
                          ? _c("p", [
                              _vm._v(
                                "还剩" +
                                  _vm._s(_vm.limitTime.days) +
                                  "天" +
                                  _vm._s(_vm.limitTime.hours) +
                                  "小时自动确认"
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-col",
                      { staticClass: "colRight", attrs: { span: "10" } },
                      [
                        _c("img", {
                          staticClass: "imgStyle",
                          attrs: { src: _vm.imgUrl, alt: "" }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.dataDetails.deliveryMethodCode === "COME_ON"
              ? _c("div", { staticClass: "transactionInfo" }, [
                  _c("p", { staticClass: "pW" }, [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(
                        "网点员工名称：" +
                          _vm._s(_vm.dataDetails.merchantOutlet.sender)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "phone" }, [
                      _vm._v(_vm._s(_vm.dataDetails.merchantOutlet.phone))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pT" }, [
                    _c("span", [
                      _vm._v(
                        "自提网点：" +
                          _vm._s(_vm.dataDetails.merchantOutlet.outletName)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "address" }, [
                    _c(
                      "p",
                      { staticClass: "pLocation" },
                      [_c("van-icon", { attrs: { name: "location" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "pAddress" }, [
                      _vm._v(
                        "网点地址：" +
                          _vm._s(_vm.dataDetails.merchantOutlet.area) +
                          _vm._s(_vm.dataDetails.merchantOutlet.address)
                      )
                    ])
                  ])
                ])
              : _c("div", { staticClass: "transactionInfo" }, [
                  _c("p", { staticClass: "pPeople" }, [
                    _c("span", { staticClass: "spanPeople" }, [
                      _vm._v(_vm._s(_vm.dataDetails.receiver))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "spanPhone" }, [
                      _vm._v(_vm._s(_vm.dataDetails.mobileNumber))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "address" }, [
                    _c(
                      "p",
                      { staticClass: "pLocation" },
                      [_c("van-icon", { attrs: { name: "location" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "pAddress" }, [
                      _vm._v(
                        _vm._s(_vm.dataDetails.area) +
                          _vm._s(_vm.dataDetails.address)
                      )
                    ])
                  ])
                ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "commodityDetails" },
              [
                _c("p", { staticClass: "title" }, [
                  _vm.dataDetails.deliveryMethodCode === "EXPRESS_DELIVERY"
                    ? _c("img", {
                        staticClass: "kdImg",
                        attrs: { src: _vm.kd, alt: "" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataDetails.deliveryMethodCode === "EXPRESS_DISTRIBUTION"
                    ? _c("img", { attrs: { src: _vm.ps, alt: "" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataDetails.deliveryMethodCode === "COME_ON"
                    ? _c("img", { attrs: { src: _vm.zt, alt: "" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dataDetails.deliveryMethodCode === "TRANSPORT_DIRECT"
                    ? _c("img", { attrs: { src: _vm.zy, alt: "" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.dataDetails.businessTypeStr +
                          _vm.dataDetails.deliveryMethod
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.dataDetails.memberOrderItemList, function(
                  item,
                  index
                ) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      _c(
                        "van-card",
                        {
                          attrs: {
                            desc: item.specificationValue,
                            title: item.productName,
                            thumb: item.productImg
                          }
                        },
                        [
                          _c("template", { slot: "desc" }, [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.godetail(item)
                                  }
                                }
                              },
                              [
                                _c("p", { staticClass: "descP" }, [
                                  _vm._v(_vm._s(item.specificationValue))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "numP" }, [
                                  _c("span", { staticClass: "p1" }, [
                                    _vm._v(
                                      "￥" +
                                        _vm._s(
                                          _vm.ESVBase.numberTofixed(
                                            item.productPrice
                                          )
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "p2" }, [
                                    _vm._v("×" + _vm._s(item.quantity))
                                  ])
                                ])
                              ]
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "refundBox" },
                        [
                          _vm.invoiceBtnShow
                            ? _c("BtnAss", {
                                attrs: { text: _vm.invoiceBtnText, type: 1 },
                                on: {
                                  fromChildClick: function($event) {
                                    _vm.invoiceClick(item, index)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showAfterSaleBtn
                            ? _c("BtnAss", {
                                attrs: { text: _vm.thText, type: 1 },
                                on: {
                                  fromChildClick: function($event) {
                                    _vm.openAfterSales(item, index)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.dataDetails.status === _vm.orderStatus.closed
                        ? _c("div", { staticClass: "refundP" }, [
                            item.status === "2"
                              ? _c("p", { staticClass: "statusP" }, [
                                  _c("span", [_vm._v(_vm._s(item.statusStr))])
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "commodityPrice" }, [
                  _c("p", [
                    _c("span", { staticClass: "pull-left" }, [
                      _vm._v("物流方式")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pull-right" }, [
                      _vm._v(_vm._s(_vm.dataDetails.deliveryMethod))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.dataDetails.deliveryMethodCode === "COME_ON"
                    ? _c("p", [
                        _c("span", { staticClass: "pull-left" }, [
                          _vm._v("自提网点")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "pull-right" }, [
                          _vm._v(_vm._s(_vm.dataDetails.outletName))
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { staticClass: "pull-left" }, [
                      _vm._v("物流运费")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pull-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dataDetails.freightAmount !== undefined &&
                            _vm.dataDetails.freightAmount !== 0
                            ? "¥" +
                                _vm.ESVBase.numberTofixed(
                                  _vm.dataDetails.freightAmount
                                )
                            : "¥0.00"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { staticClass: "pull-left" }, [
                      _vm._v("套装优惠")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pull-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dataDetails.groupBenefitAmount !== undefined &&
                            _vm.dataDetails.groupBenefitAmount !== 0
                            ? "- ¥" +
                                _vm.dataDetails.groupBenefitAmount.toFixed(2)
                            : "¥0.00"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { staticClass: "pull-left" }, [
                      _vm._v("活动优惠")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pull-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dataDetails.shopDiscountAmount !== undefined &&
                            _vm.dataDetails.shopDiscountAmount !== 0
                            ? "- ¥" +
                                _vm.dataDetails.shopDiscountAmount.toFixed(2)
                            : "¥0.00"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { staticClass: "pull-left" }, [
                      _vm._v("优惠券抵扣")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pull-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dataDetails.couponDiscountAmount !== undefined &&
                            _vm.dataDetails.couponDiscountAmount !== 0
                            ? "- ¥" +
                                _vm.dataDetails.couponDiscountAmount.toFixed(2)
                            : "¥0.00"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { staticClass: "pull-left" }, [
                      _vm._v("积分抵扣")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pull-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dataDetails.maxDeductionAmount !== undefined &&
                            _vm.dataDetails.maxDeductionAmount !== 0
                            ? "- ¥" +
                                _vm.dataDetails.maxDeductionAmount.toFixed(2)
                            : "¥0.00"
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "orderPrice" }, [
                  _c("p", [
                    _c("span", { staticClass: "pull-left" }, [
                      _vm._v("实付款(含运费)")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pull-right" }, [
                      _vm._v(
                        "¥" +
                          _vm._s(
                            _vm.ESVBase.numberTofixed(_vm.dataDetails.payAmount)
                          )
                      )
                    ])
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "orderMessage" }, [
              _c("p", [
                _vm._v("订单编号："),
                _c("span", { attrs: { id: "spanId" } }, [
                  _vm._v(_vm._s(_vm.dataDetails.orderCode))
                ]),
                _c("span", { staticClass: "fz", on: { click: _vm.copyText } }, [
                  _vm._v("复制")
                ])
              ]),
              _vm._v(" "),
              _vm.dataDetails.paymentTime
                ? _c("p", [
                    _vm._v("付款时间：" + _vm._s(_vm.dataDetails.paymentTime))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.dataDetails.deliveryTime
                ? _c("p", [
                    _vm._v("发货时间：" + _vm._s(_vm.dataDetails.deliveryTime))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lxkf" }, [
              _c("p", [
                _c("a", { attrs: { href: _vm.contactCustomer } }, [
                  _c("span", [_vm._v("联系客服")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: _vm.kfUrl, alt: "" } })
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: {
              buttonStyle: _vm.dataDetails.status !== _vm.orderStatus.toDeliver
            }
          },
          [
            _vm.dataDetails.status === _vm.orderStatus.unpay
              ? _c(
                  "div",
                  [
                    _c("BtnAss", {
                      attrs: { text: _vm.textParentCancel, type: 1 },
                      on: {
                        fromChildClick: function($event) {
                          _vm.cancelOrder(_vm.dataDetails)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("BtnAss", {
                      attrs: { text: _vm.payParent, type: 2 },
                      on: {
                        fromChildClick: function($event) {
                          _vm.paymentClick(_vm.dataDetails)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataDetails.status === _vm.orderStatus.pendingReceipt
              ? _c(
                  "div",
                  [
                    _vm.dataDetails.deliveryMethodCode !== "COME_ON"
                      ? _c("BtnAss", {
                          attrs: { text: _vm.watchWl, type: 1 },
                          on: {
                            fromChildClick: function($event) {
                              _vm.queryLogistics(_vm.dataDetails)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BtnAss", {
                      attrs: { text: _vm.okProduct, type: 2 },
                      on: {
                        fromChildClick: function($event) {
                          _vm.collectGoods(_vm.dataDetails)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataDetails.status === _vm.orderStatus.comment
              ? _c(
                  "div",
                  [
                    _vm.dataDetails.deliveryMethodCode !== "COME_ON"
                      ? _c("BtnAss", {
                          attrs: { text: _vm.watchWl, type: 1 },
                          on: {
                            fromChildClick: function($event) {
                              _vm.queryLogistics(_vm.dataDetails)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BtnAss", {
                      attrs: { text: _vm.deleteText, type: 1 },
                      on: {
                        fromChildClick: function($event) {
                          _vm.deleteOrder(_vm.dataDetails)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("BtnAss", {
                      attrs: { text: _vm.pjText, type: 2 },
                      on: {
                        fromChildClick: function($event) {
                          _vm.openEvaluate(_vm.dataDetails)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataDetails.status === _vm.orderStatus.closed
              ? _c(
                  "div",
                  [
                    _c("BtnAss", {
                      attrs: { text: _vm.deleteText, type: 1 },
                      on: {
                        fromChildClick: function($event) {
                          _vm.deleteOrder(_vm.dataDetails)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataDetails.status === _vm.orderStatus.completde
              ? _c(
                  "div",
                  [
                    _c("BtnAss", {
                      attrs: { text: _vm.deleteText, type: 1 },
                      on: {
                        fromChildClick: function($event) {
                          _vm.deleteOrder(_vm.dataDetails)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.dataDetails.deliveryMethodCode !== "COME_ON"
                      ? _c("BtnAss", {
                          attrs: { text: _vm.watchWl, type: 1 },
                          on: {
                            fromChildClick: function($event) {
                              _vm.queryLogistics(_vm.dataDetails)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("wxShareLoading")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }